import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getToken } from "./../../utils/utils";

export const fetchNews = createAsyncThunk(
  "fetchNews",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/controller/news/list.php?page=" +
      data.page +
      "&limit=" +
      data.limit;
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const fetchNewsSearch = createAsyncThunk(
  "fetchNewsSearch",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/controller/news/search.php?search=" +
      data;
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.news;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const fetchNewsEdit = createAsyncThunk(
  "fetchNewsEdit",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/controller/news/details.php?id=" +
      data.id;
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.news[0];
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const saveNews = createAsyncThunk("saveNews", async (data, thunkAPI) => {
  const url = process.env.REACT_APP_API_URL + "/controller/news/create.php";
  const authorization = getToken();
  const options = {
    method: "post",
    headers: {
      Authorization: "Bearer " + authorization,
      "Content-Type": "multipart/form-data",
    },
    url,
    data: data,
  };
  const response = await axios(options)
    .then((result) => {
      if (result.data) {
        if (result.data.news) return result.data.news;
        else return result.data.message;
      }
    })
    .catch((error) => {
      return error.code;
    });

  return response;
});

export const editNews = createAsyncThunk("editNews", async (data, thunkAPI) => {
  const url = process.env.REACT_APP_API_URL + "/controller/news/update.php";
  const authorization = getToken();
  const options = {
    method: "post",
    headers: {
      Authorization: "Bearer " + authorization,
      "Content-Type": "multipart/form-data",
    },
    url,
    data: data,
  };
  const response = await axios(options)
    .then((result) => {
      if (result.data) {
        if (result.data.news) return result.data.news;
        else return result.data.message;
      }
    })
    .catch((error) => {
      return error.code;
    });

  return response;
});

export const deleteNews = createAsyncThunk(
  "deleteNews",
  async (id, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL + "/controller/news/delete.php?id=" + id;
    const authorization = getToken();
    const options = {
      method: "delete",
      headers: { Authorization: "Bearer " + authorization },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.status) {
          return result.status;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);
